export default __webpack_public_path__ + "static/media/profile_background.622bae8d.jpg";